export default function() {
  return Array.from(this);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/nodes.js
// module id = 44
// module chunks = 0